import { grey } from "designSystem/styles/color";
import { Box, MasonryGrid } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import Image1 from "./Image1.jpg";
import Image2 from "./Image2.jpg";
import Image4 from "./Image4.jpg";
import Image5 from "./Image5.jpg";
import Image6 from "./Image6.jpg";
import Image7 from "./Image7.jpg";

export default () => {
	const imgList = [
		{
			link: Image1,
			height: 360,
			width: 180,
		},
		{
			link: Image2,
			height: 370,
			width: 185,
		},
		{
			height: 128,
			width: 100,
		},
		{
			link: Image4,
			height: 370,
			width: 185,
		},
		{
			link: Image5,
			height: 370,
			width: 185,
		},
		{
			link: Image6,
			height: 795,
			width: 537,
		},
		{
			link: Image7,
			height: 412,
			width: 735,
		},
	];

	return (
		<Box
			bgcolor={grey[100]}
			border={STANDARD_BORDER_STYLE}
			display="inline-block"
			m={4}
		>
			<MasonryGrid
				height={500}
				imageList={imgList}
				width={300}
			/>
		</Box>
	);
};